import { render, staticRenderFns } from "./creditLimitExceeded.vue?vue&type=template&id=aa2dc6d0&"
import script from "./creditLimitExceeded.vue?vue&type=script&lang=js&"
export * from "./creditLimitExceeded.vue?vue&type=script&lang=js&"
import style0 from "./creditLimitExceeded.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports